
import React , {  Children, useEffect, useState } from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { GrClose, GrSearch } from "react-icons/gr";
import { GiHamburgerMenu } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import { setLang, setSelected, setThemeMode } from "../store/reducers/CartReducer";
import { Footer } from "./Footer";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
export const  Header = () => {




  const [showMenu, setShowMenu] = useState(false);

  const [whats, setWhats] = useState(false);

  const handleClose = () => {setShowMenu(false)
    
  }
const lang = useSelector((state) => state.cart.lang);

  const setLang_ = () => {
    dispatch(setLang())
    if(lang === 'ar'){
      localStorage.setItem('lang','en')
    }else{
      localStorage.setItem('lang','ar')
    }
  }
 

const theme = useSelector((state) => state.cart.theme);
  const toggleThemeMode = () => {
    dispatch(setThemeMode())
    if(theme === 'LM'){
      localStorage.setItem('theme','DM')
    }else{
      localStorage.setItem('theme','LM')
    }
  }
 


const [width, setWidth] = useState(window.innerWidth);
  
useEffect(() => {
  const handleResize = () => setWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);
//  console.log(window.innerWidth);
  return () => window.removeEventListener("resize", handleResize);
  

}, []);


useEffect(() => {
  setTimeout(() => {
   
   }, 1000)
}, []);



const dispatch = useDispatch();





const navLinks = [
  {
    id: "/",
    title:  lang === 'en' ?  "Home" : " الرئيسية ",
    Children:[]
  },

  
  {
    id: "Products",
    title:  lang === 'en' ? "Products" : "المنتجات",
    Children:[]
  },
  {
    id: "Pharmacies",
    title:  lang === 'en' ? "Pharmacies" : "الصيدليات",
    Children:[]
  },

];


const selected =  useSelector((state) => state.cart.selected) ;

const setSelected_ = (value)=>{
  dispatch(setSelected({select:value}))
} 


const [visible, setVisible] = useState(false) 

const toggleVisible = () => { 
  const scrolled = document.documentElement.scrollTop; 
  if (scrolled > 50){ 
    setVisible(true) 
    setWhats(true);
  }  
  else{ 
    setVisible(false) 
  } 
}; 

window.addEventListener('scroll', toggleVisible); 


const navigate = useNavigate();

const onClickBack = () => navigate(-1)

  return (
    <div ><header dir={lang === 'en' ? 'ltr' : 'rtl'} style={{zIndex:1000}} className= {`  fixed h-[80px] w-full flex flex-row items-center justify-between sm:justify-around p-2  ${visible ? theme === 'LM' ? 'bg-[#ffffff]/95  ' : 'bg-[#1F1F1F]/95  ' : 'transparent ' } `}>
   <div  className="flex items-center gap-1 ">
    {
      selected > 0 ?
    
    lang === 'en' ?  
      <FaArrowLeft onClick={onClickBack} size={25} color={theme === 'LM' ? "#2196F3" : "#FF9800"} className="m-auto cursor-pointer hover:opacity-70 " />
    :
      <FaArrowRight onClick={onClickBack}  size={25} color={theme === 'LM' ? "#2196F3" : "#FF9800"} className="m-auto cursor-pointer hover:opacity-70 " />

      :''
    }
   <Link 
     onClick={()=>{
      setSelected_(0)
      handleClose()
      window.scrollTo(0, 0)
      }} 
    to="/"
    className="m-auto flex items-center  hover:opacity-70 ">
    <img className="w-[150px] " src="/Artboard.svg" alt="dawasmart"/>
    <h1
   
    style={{textAlign:'center',fontFamily:'CairoExtraBold', }}
    
      className="hidden text-primary text-[25px]  md:text-[35px] lg:text-[40px] xl:text-[45px] "
    >
   {lang==='en' ? 'Dawa Smart' : 'دواء سمارت'}
      
      </h1>
</Link>
   </div>
  


{width < 600 ?

  <>

 
 

  <div  className="flex gap-4">
{/*<button  className="flex items-center text-zinc-500 hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]" >
<GrSearch className="m-auto" />
</button>*/}





      <button
     id="show"
      aria-label="menu"
        onClick={() => setShowMenu(!showMenu)}
        className=" text-zinc-500 hover:text-gray-500"
      >
        {showMenu ? <GrClose className="mt-5" size={25} /> : <GiHamburgerMenu size={25} />}
   


       
{ showMenu ? 
        <>
      <div className="dropdown ">



  <div  className={`dropdown-content  ${lang === 'en' ? "right-[25px]" : "left-[25px]"}`}>

  {navLinks.map((item,i)=>
<>
<br></br>
<Link key={i}  style={{fontFamily:'CairoBold'}} onClick={()=>{
handleClose()
setSelected_(i)
  }}  aria-label={item.title} className={`${selected === i ?  theme === 'LM' ? 'text-primary' : 'text-primary_'  : 'hover:opacity-70' } `} to={item.id} >{item.title}</Link>



<br></br>
</>
)}



  </div>

  </div>
  </>
  
   :''
     
      }
      </button>
      <button
        onClick={() => {setLang_()}}
       style={{fontFamily:'CairoBold'}}
       className={`${showMenu ?  'mt-[19px]' :''} text-zinc-500  hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]`}
          aria-label="language"
      >
{lang === 'en' ? 'AR' : 'EN'}
      </button>
<button
        onClick={() => {toggleThemeMode()}}
       style={{fontFamily:'CairoBold'}}
       className={`${showMenu ?  'mt-[19px]' :''} text-zinc-500  hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]`}
          aria-label="language"
      >
<img src={theme === 'LM' ?  `/Icons/dark.png`  : `/Icons/light.png`} alt={`Toggle Theme Mode`} />
      </button>
      </div>
</>
:


<>
<nav dir={`${lang === 'en' ? 'ltr' : 'rtl'}`}  className=" flex justify-between items-center gap-3 ">

{navLinks.map((item,i)=>

  <Link  aria-label={item.title} key={i} onClick={()=>{
handleClose()
setSelected_(i)
  }} style={{fontFamily:'CairoBold'}}  className={`${selected === i ?  theme === 'LM' ? 'text-primary' : 'text-primary_'  : 'hover:opacity-70' } `}  to={item.id} >{item.title}</Link>


)} 

   </nav>
    
<div className="flex gap-4">
{/*<button  className="flex items-center text-zinc-500 hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]" >
<GrSearch className="m-auto" />
</button>*/}

<button
           onClick={() => {setLang_()}}
       style={{fontFamily:'CairoBold'}}
       className="text-zinc-500 hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]"
          aria-label="language"
      >
{lang === 'en' ? 'Ar' : 'EN'}
      </button>
<button
        onClick={() => {toggleThemeMode()}}
       style={{fontFamily:'CairoBold'}}
       className={`${showMenu ?  'mt-[19px]' :''} text-zinc-500  hover:opacity-70 h-[30px] w-[30px] rounded bg-[#dbdbdb]`}
          aria-label="language"
      >
<img src={theme === 'LM' ?  `/Icons/dark.png`  : `/Icons/light.png`} alt={`Toggle Theme Mode`} />
      </button>
</div>
   </> 
}
 

  </header>

{/*
<a style={{zIndex:100}} className= {`${whats ? 'opacity-[1]' : 'opacity-[0]'}  transition-all transition-discrete duration-500 fixed bottom-[5%] ${lang === 'en' ? 'right-[20px]' : ' left-[20px]'}`}  target='__blink' href="https://wa.me/+967774179096" >
  <img width='50px' height='50px' src="https://dev.dawasmart.com/img/WhatsApp.png" alt="Future Swift WhatsApp"  />
</a>
*/}


<Outlet />


<Footer lang={lang} theme={theme} />
  
</div>
   
  );
}
